"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { type ComponentProps } from "react";
import { LeftChevron } from "../icons/left-chevron";
import { googleAnalyticsEvent } from "~/utils/googleAnalyticsUtils";

export const GoBack = ({
  href,
  text,
  usePrevRoute,
  gaAction,
  props,
}: {
  href: string;
  text: string;
  props?: ComponentProps<"button">;
  usePrevRoute?: boolean;
  // Optional GA event name fired on click (e.g. link_back_to_courses).
  gaAction?: string;
}) => {
  const router = useRouter();

  return (
    <Link
      href={usePrevRoute ? "" : href}
      onClick={() => {
        if (gaAction) googleAnalyticsEvent({ action: gaAction });
        if (usePrevRoute) router.back();
      }}
      data-testid="back-to-page-id" prefetch={false}
    >
      <button
        className="flex items-center gap-1"
        {...props}
        data-testid="left-chevron-id"
      >
        <LeftChevron className="h-[0.875rem] w-[0.875rem]" />
        <div className="text-[0.875rem] text-primary">{text}</div>
      </button>
    </Link>
  );
};
